jQuery(function ($) {
  /** Accueil */
  new Swiper(".swiper-accueil", {
    loop: true,
    effect: "fade",
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
  });

  let AccueilthumbSwiper = new Swiper(".swiper-accueil-galeries-thumb", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
  });
  new Swiper(".swiper-accueil-galeries", {
    autoplay: {
      delay: 6000,
      disableOnInteraction: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: AccueilthumbSwiper,
    },
  });

  /** Modulaire */
  $(".swiper-galerie").each(function (index) {
    $(this).addClass("swiper-galerie-" + index);

    new Swiper(".swiper-galerie-" + index, {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    });
  });

  $(".wrap-swipers-galeries").each(function (index) {
    $(this)
      .find(".swiper-galeries")
      .addClass("swiper-galeries-" + index);
    $(this)
      .find(".swiper-galeries-thumb")
      .addClass("swiper-galeries-thumb-" + index);
    let thumbSwiper = new Swiper(".swiper-galeries-thumb-" + index, {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
    });
    let mainSwiper = new Swiper(".swiper-galeries-" + index, {
      autoplay: {
        delay: 6000,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: thumbSwiper,
      },
    });
  });
});
